import {
  isEmpty,
  map,
  reject
} from 'ramda'
import React,
{
  Component,
  Fragment,
  useState
} from 'react'
import { useHistory } from 'react-router-dom'

import {
  Box,
  Tabs 
} from '@driftt/dds'
import { Div } from '@driftt/tide-core'
import {
  getAllContactProperties,
  getDriftIntel,
  getDriftProperties,
  getGeoIPProperties,
  getSystemProperties,
} from 'api/contacts'
import { ATTRIBUTE_STATUS } from 'components/Settings/PropertyLists/constants'

import DetailCard from './DetailCard'
import DriftIntelCard from './DriftIntelCard'
import PropertyGroupCard from './PropertyGroupCard'
import Timeline from './Timeline'
class ContactDetail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoaded: false,
      driftProperties: null,
      customProperties: null,
      geoIPProperties: null,
      driftIntel: { derivedObjects: { 1: { value: {} } } }
    }
  }

  componentDidMount() {
    this.getDetails()
  }

  getDetails = async () => {
    try {
      const { data: driftProps } = await getDriftProperties()
      const { data: systemProps } = await getSystemProperties()
      const { data: allProperties } = await getAllContactProperties()
      const { data: geoIPProperties } = await getGeoIPProperties(this.props.contact.id)
      const { data: driftIntel } = await getDriftIntel(this.props.contact.id, [1])

      const shouldHideProp = (property) => {
        return property.status === ATTRIBUTE_STATUS.ARCHIVED
      }

      const cleanedAllProps = reject(property => {
        const hasInclusionOverride = property.name === '_madkudu_score'

        if (hasInclusionOverride) {
          return false
        }

        const isSystemProp = systemProps.includes(property.name)
        const isDriftProp = driftProps.includes(property.name)

        return isSystemProp || isDriftProp || shouldHideProp(property)
      }, allProperties)

      const customProps = map((property) => property.name, cleanedAllProps)

      this.setState({
        isLoaded: true,
        driftProperties: driftProps,
        customProperties: customProps,
        geoIPProperties,
        driftIntel: driftIntel
      })
    } catch (e) {
      console.warn(e)
    }
  }

  render() {
    const {
      driftProperties,
      customProperties,
      geoIPProperties,
      driftIntel,
      isLoaded
    } = this.state
    const {
      contact,
      onAddData,
      rawProperties
    } = this.props
    const hasDerivedObjects = driftIntel && driftIntel.derivedObjects && driftIntel.derivedObjects[1]
    const companyDataPresent = hasDerivedObjects && driftIntel.derivedObjects[1].value.companyDataPresent
    const personalDataPresent = hasDerivedObjects && driftIntel.derivedObjects[1].value.personalDataPresent

    return (
      <Div className="contact-details--attributes-container">
        {isLoaded &&
          <Fragment>
            <DetailCard
              fields={driftProperties}
              rawProperties={rawProperties}
              contact={contact}
              iconName="drift-logo-round"
              iconWidth={20}
              title="Drift Attributes"
              maxLength={3}
              onAddData={onAddData}
            />
            <DetailCard
              fields={customProperties}
              rawProperties={rawProperties}
              contact={contact}
              iconName="edit-1"
              iconWidth={15}
              title="Custom Attributes"
              maxLength={3}
              onAddData={onAddData}
            />
            {!isEmpty(geoIPProperties) &&
              <PropertyGroupCard
                groupName="Geo IP"
                iconName="targeting-geolocation"
                properties={geoIPProperties}
              />
            }
            {companyDataPresent &&
              <DriftIntelCard
                intelData={driftIntel.derivedObjects[1].value.companyData}
                groupName='DRIFT INTEL COMPANY'
              />
            }
            {personalDataPresent &&
              <DriftIntelCard
                intelData={driftIntel.derivedObjects[1].value.personalData}
                groupName='DRIFT INTEL PERSONAL'
              />
            }
          </Fragment>
        }
      </Div>
    )
  }
}

const DetailPane = ({
  contact,
  rawProperties,
  onAddData
}) => {
  const history = useHistory()
  const activeTabIsActivity = history.location.search.includes('view=activity')
  const [activeTab, setActiveTab] = useState(activeTabIsActivity ? 'activity' : 'attributes')

  if (isEmpty(contact)) {
    return null
  }

  const tabs = [
    {
      value: 'attributes',
      label: 'Attributes',
      content: <ContactDetail contact={contact} rawProperties={rawProperties}
        onAddData={onAddData} />
    },
    {
      value: 'activity',
      label: 'Activity timeline',
      content: <Timeline contact={contact} />
    }
  ]

  return (
    <Box css={{ padding: '$2 $3' }}>
      <Tabs
        value={activeTab}
        options={tabs}
        onValueChange={setActiveTab}
      />
    </Box>
    
  )
}


export default DetailPane
